var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaicreditgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E7F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 9.33325C12.3179 9.33325 9.33325 12.3179 9.33325 15.9999C9.33325 19.6819 12.3179 22.6666 15.9999 22.6666C19.6819 22.6666 22.6666 19.6819 22.6666 15.9999C22.6666 12.3179 19.6819 9.33325 15.9999 9.33325ZM15.9999 9.99992C15.9999 11.5912 15.3678 13.1173 14.2426 14.2426C13.1173 15.3678 11.5912 15.9999 9.99992 15.9999C11.5912 15.9999 13.1173 16.6321 14.2426 17.7573C15.3678 18.8825 15.9999 20.4086 15.9999 21.9999C15.9999 20.4086 16.6321 18.8825 17.7573 17.7573C18.8825 16.6321 20.4086 15.9999 21.9999 15.9999C20.4086 15.9999 18.8825 15.3678 17.7573 14.2426C16.6321 13.1173 15.9999 11.5912 15.9999 9.99992Z",
    fill: "url(#paint0_linear_54840_23393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54840_23393",
    x1: 9.33325,
    y1: 9.21882,
    x2: 23.9123,
    y2: 10.7587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7621FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaicreditgroup);
export default __webpack_public_path__ + "static/media/icon.aicredit.group.46d0e4273d8890b54e3fb815ecd61aa6.svg";
export { ForwardRef as ReactComponent };